import { SubscriptionTier } from '@/actions/dtos/subscription';
import { Advantage } from '@/types/advantage';
import {
  faPeopleGroup,
  faMagnifyingGlass,
  faListUl,
  faBookmark,
  faMagnifyingGlassArrowsRotate,
  faBoxArchive,
  faUnlockKeyhole,
  faMessagesQuestion,
  faMessageLines,
  faFileExport,
  faTreasureChest,
  faWebhook,
} from '@fortawesome/pro-duotone-svg-icons';

export const advantages: Advantage[] = [
  {
    label: 'Zugang zu Ausschreibungen',
    tooltip: 'Ermöglicht die Teilnahme an Ausschreibungen, sowie den Download der Dokumente.',
    icon: faUnlockKeyhole,
    data: new Map([
      [SubscriptionTier.BASIC, '1'],
      [SubscriptionTier.PROFESSIONAL, '✓'],
      [SubscriptionTier.ULTIMATE, '✓'],
      [SubscriptionTier.ENTERPRISE, '✓'],
    ]),
  },
  {
    label: 'Nutzerkonten',
    tooltip: 'Arbeiten Sie mit mehreren Personen als Team zusammen und nutzen Sie die Plattform gemeinsam.',
    icon: faPeopleGroup,
    data: new Map([
      [SubscriptionTier.BASIC, '1'],
      [SubscriptionTier.PROFESSIONAL, '1'],
      [SubscriptionTier.ULTIMATE, '5'],
      [SubscriptionTier.ENTERPRISE, 'Unbegrenzt'],
    ]),
  },
  {
    label: 'Suchanfragen / Monat',
    tooltip: 'Nutzen Sie unsere Suche mit vielen Filter-Optionen und KI-Bewertung der Ergebnisse.',
    icon: faMagnifyingGlass,
    data: new Map([
      [SubscriptionTier.BASIC, '25'],
      [SubscriptionTier.PROFESSIONAL, '250'],
      [SubscriptionTier.ULTIMATE, '500'],
      [SubscriptionTier.ENTERPRISE, 'Unbegrenzt'],
    ]),
  },
  {
    label: 'Suchergebnisse',
    tooltip: 'Die Anzahl der Ergebnisse ihrer Suchanfragen. Sie erhalten immer die Top-Ergebnisse.',
    icon: faListUl,
    data: new Map([
      [SubscriptionTier.BASIC, '10'],
      [SubscriptionTier.PROFESSIONAL, '50'],
      [SubscriptionTier.ULTIMATE, '100'],
      [SubscriptionTier.ENTERPRISE, 'Unbegrenzt'],
    ]),
  },
  {
    label: 'Suchprofile',
    tooltip: 'Mit Suchprofilen erhalten Sie vollautomatisiert jederzeit passende Ausschreibungen als E-Mail.',
    icon: faMagnifyingGlassArrowsRotate,
    data: new Map([
      [SubscriptionTier.BASIC, '1'],
      [SubscriptionTier.PROFESSIONAL, '3'],
      [SubscriptionTier.ULTIMATE, '10'],
      [SubscriptionTier.ENTERPRISE, 'Unbegrenzt'],
    ]),
  },
  {
    label: 'KI-Fragen',
    tooltip: 'Bequem per Chat Fragen zu Ausschreibungen auf Basis der Dokumente beantworten lassen.',
    icon: faMessagesQuestion,
    data: new Map([
      [SubscriptionTier.BASIC, '5'],
      [SubscriptionTier.PROFESSIONAL, '100'],
      [SubscriptionTier.ULTIMATE, '500'],
      [SubscriptionTier.ENTERPRISE, 'Unbegrenzt'],
    ]),
  },
  {
    label: 'Export-Funktionen',
    tooltip: 'Suchergebnisse und Favoriten als Excel-Datei exportieren.',
    icon: faFileExport,
    data: new Map([
      [SubscriptionTier.BASIC, ' '],
      [SubscriptionTier.PROFESSIONAL, '✓'],
      [SubscriptionTier.ULTIMATE, '✓'],
      [SubscriptionTier.ENTERPRISE, '✓'],
    ]),
  },
  {
    label: 'Archiv-Zugang',
    tooltip: 'Sehen Sie Ausschreibungen bei uns auch ein, nachdem sie bereits abgelaufen sind.',
    icon: faBoxArchive,
    data: new Map([
      [SubscriptionTier.BASIC, ' '],
      [SubscriptionTier.PROFESSIONAL, '✓'],
      [SubscriptionTier.ULTIMATE, '✓'],
      [SubscriptionTier.ENTERPRISE, '✓'],
    ]),
  },
  {
    label: 'Favoritenfunktion',
    tooltip: 'Markieren Sie interessante Listen einfach als Favorit um sie jederzeit wiederzufinden.',
    icon: faBookmark,
    data: new Map([
      [SubscriptionTier.BASIC, '✓'],
      [SubscriptionTier.PROFESSIONAL, '✓'],
      [SubscriptionTier.ULTIMATE, '✓'],
      [SubscriptionTier.ENTERPRISE, '✓'],
    ]),
  },
  {
    label: 'Kommentarfunktion',
    tooltip: 'Diskutieren Sie im Team oder fügen Sie einfache Notizen zu jeder Ausschreibung hinzu.',
    icon: faMessageLines,
    data: new Map([
      [SubscriptionTier.BASIC, '✓'],
      [SubscriptionTier.PROFESSIONAL, '✓'],
      [SubscriptionTier.ULTIMATE, '✓'],
      [SubscriptionTier.ENTERPRISE, '✓'],
    ]),
  },
  {
    label: 'Komfortfunktionen',
    tooltip:
      'Umkreis- und Gebietsfilter, Kalenderübertragung, Kopierfunktion, ausführliche Beschreibungen und weitere Funktionen.',
    icon: faTreasureChest,
    data: new Map([
      [SubscriptionTier.BASIC, ''],
      [SubscriptionTier.PROFESSIONAL, '✓'],
      [SubscriptionTier.ULTIMATE, '✓'],
      [SubscriptionTier.ENTERPRISE, '✓'],
    ]),
  },
  {
    label: 'Integrationen',
    tooltip:
      'Anbindung an andere Systeme mit Webhooks. Beispielsweise zur automatischen Übertragung von Suchergebnissen zu Hubspot oder Salesforce.',
    icon: faWebhook,
    data: new Map([
      [SubscriptionTier.BASIC, ''],
      [SubscriptionTier.PROFESSIONAL, ''],
      [SubscriptionTier.ULTIMATE, ''],
      [SubscriptionTier.ENTERPRISE, '✓'],
    ]),
  },
];
